// src/Components/Common/FieldWithIcon.jsx
import React, { useState } from "react";
import { Label } from "../UI/label";
import { Copy, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

const FieldWithIcon = React.forwardRef(
  (
    {
      fieldID,
      label,
      placeholder,
      value,
      onChange,
      required = false,
      iconTypes = [],
      readOnly = false,
      className = "space-y-1.5",
    },
    ref //forwardRef receives this as the second argument
  ) => {
    const [showKey, setShowKey] = useState(false);

    const handleCopy = () => {
      navigator.clipboard.writeText(value || "");
      toast.success("Copied to clipboard", { duration: 2000 });
    };

    const renderIconButton = (type) => {
      const btnClasses =
        "h-11 w-12 flex items-center justify-center bg-gray-100 border-l border-gray-300 outline-none ring-0 focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-l-gray-300 focus-visible:outline-none focus-visible:ring-offset-0 cursor-pointer";

      if (type === "copy") {
        return (
          <button
            key="copy"
            type="button"
            onClick={handleCopy}
            className={btnClasses}
            tabIndex={0}
          >
            <Copy className="h-4 w-4 text-muted-foreground" />
          </button>
        );
      }

      if (type === "key") {
        const Icon = showKey ? EyeOff : Eye;
        return (
          <button
            key="key"
            type="button"
            onClick={() => setShowKey((p) => !p)}
            className={btnClasses}
            tabIndex={0}
          >
            <Icon className="h-4 w-4 text-muted-foreground" />
          </button>
        );
      }
      return null;
    };

    return (
      <div className={className} ref={ref}>
        {label && (
          <Label htmlFor={fieldID} required={required}>
            {label}
          </Label>
        )}
        <div className="sahi-input flex items-center w-full h-11 border border-gray-300 rounded-lg overflow-hidden">
          <input
            id={fieldID}
            name={fieldID}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            readOnly={
              iconTypes.length === 1 && iconTypes[0] === "copy"
                ? true
                : readOnly
            }
            type={
              iconTypes.includes("key") && !showKey ? "password" : "text"
            }
            autoComplete="off"
            className={`flex-1 h-full border-0 px-3 text-sm bg-white placeholder:text-muted-foreground focus:outline-none focus:ring-0 ${
              iconTypes.length === 1 && iconTypes[0] === "copy"
                ? "cursor-not-allowed"
                : "cursor-text"
            }`}
          />
          {iconTypes.map((type) => renderIconButton(type))}
        </div>
      </div>
    );
  }
);

export default FieldWithIcon;
